(function () {
  var firedStore = window.__shokzPillarProductViewFired || Object.create(null);
  window.__shokzPillarProductViewFired = firedStore;

  function parsePrice(priceStr) {
    if (!priceStr) return 0;
    return Number(String(priceStr).replace(/[£€$]/g, '').replace(/,/g, '.').trim()) || 0;
  }

  function resolveCurrencyCode(parts) {
    var symbol = (parts[11] || '').trim();
    if (symbol === '€') return 'EUR';
    if (symbol === '£') return 'GBP';
    if (symbol === '$') return 'USD';
    if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) {
      return Shopify.currency.active;
    }
    return 'EUR';
  }

  function getListMeta(section) {
    var listId = 'pillar_product';

    if (section) {
      var configured = section.getAttribute('data-pillar-ga-list-id');
      if (configured) listId = configured.trim();
    }

    return {
      listId: listId,
      listName: listId
    };
  }

  function getMappedMeta(sku) {
    var itemName = '';
    var itemVariant = '';
    var itemCategory = '';
    var itemCategory2 = 'Standard';

    if (
      typeof product_handle_map !== 'undefined' &&
      product_handle_map.has(sku) &&
      typeof product_handle_valueMap !== 'undefined' &&
      product_handle_valueMap[sku]
    ) {
      var mapped = product_handle_valueMap[sku];
      itemName = mapped[0] || '';
      itemVariant = mapped[1] || '';
      itemCategory = mapped[2] || '';
      itemCategory2 = mapped[3] || itemCategory2;
    }

    return {
      item_name: itemName,
      item_variant: itemVariant,
      item_category: itemCategory,
      item_category2: itemCategory2
    };
  }

  function getDiscount(slide) {
    var tag = slide.querySelector('.product-tag');
    if (!tag || !tag.textContent) return 0;

    var match = tag.textContent.trim().match(/(\d+)\s*%/);
    return match ? match[1] + '%' : 0;
  }

  function buildGaItem(slide, parts, options) {
    options = options || {};
    var sku = parts[0] || '';
    if (!sku) return null;

    var mapped = getMappedMeta(sku);
    var currency = resolveCurrencyCode(parts);
    var colorValue = (parts[6] || '').replace('Default Title', 'none');
    var listMeta = options.listMeta || {
      listId: parts[3] || '',
      listName: parts[4] || ''
    };
    var itemListName = options.navigationItemListName
      ? 'Navigation _ ' + listMeta.listName
      : listMeta.listName;

    return {
      item_id: sku,
      item_name: mapped.item_name,
      discount: getDiscount(slide),
      index: Number(parts[2]) || 0,
      item_list_id: listMeta.listId,
      item_list_name: itemListName,
      item_category: mapped.item_category,
      item_category2: mapped.item_category2,
      item_category3: colorValue,
      item_variant: mapped.item_variant,
      item_brand: 'SHOKZ',
      price: parsePrice(parts[9]),
      quantity: Number(parts[10]) || 1,
      currency: currency
    };
  }

  function getFireKey(slide, sku, index) {
    var section = slide.closest('.section-pillar-product');
    var sectionClass = '';

    if (section && section.className) {
      var match = section.className.match(/section-pillar-product-[^\s]+/);
      sectionClass = match ? match[0] : '';
    }

    return window.location.pathname + '|' + sectionClass + '|' + sku + '|' + index;
  }

  function getSlideProductParts(slide) {
    if (!slide) return null;

    var dataEl = slide.querySelector('.product-data-div-first');
    if (!dataEl) return null;

    var productData = dataEl.getAttribute('data-product-data');
    if (!productData) return null;

    return productData.split('::');
  }

  function trackViewItemList(item) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'view_item_list',
      event_parameters: {
        item_list_id: item.item_list_id,
        item_list_name: item.item_list_name,
        currency: item.currency,
        items: [item]
      }
    });
  }

  function trackSelectItem(slide, buttonName) {
    var parts = getSlideProductParts(slide);
    if (!parts) return;

    var section = slide.closest('.section-pillar-product');
    var listMeta = getListMeta(section);
    var item = buildGaItem(slide, parts, {
      listMeta: listMeta,
      navigationItemListName: true
    });
    var buttonLabel = (buttonName || '').trim();

    if (!item || !buttonLabel) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'select_item',
      event_parameters: {
        item_list_id: listMeta.listId,
        item_list_name: listMeta.listName,
        button_name: buttonLabel,
        items: [item]
      }
    });
  }

  function bindSlideViewTracking(slide) {
    if (!slide || slide.getAttribute('data-pillar-ga-bound') === 'true') return;

    var parts = getSlideProductParts(slide);
    if (!parts) return;

    var fireKey = getFireKey(slide, parts[0] || '', parts[2] || '');
    if (firedStore[fireKey]) return;

    var sentinel = slide.querySelector('[data-pillar-product-view-sentinel]');
    if (!sentinel) return;

    if (!('IntersectionObserver' in window)) return;

    slide.setAttribute('data-pillar-ga-bound', 'true');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || firedStore[fireKey]) return;

        firedStore[fireKey] = true;
        observer.disconnect();

        var item = buildGaItem(slide, parts);
        if (!item || !item.item_id) return;
        trackViewItemList(item);
      });
    }, {
      threshold: 0
    });

    observer.observe(sentinel);
  }

  function initPillarProductViewTracking(root) {
    var scope = root || document;
    var slides = scope.querySelectorAll('.product-card-container .swiper-slide');
    slides.forEach(bindSlideViewTracking);
  }

  function getProductLinkButtonName(productLink) {
    if (!productLink) return 'Shop nu';

    var label = productLink.querySelector('span');
    var text = label ? label.textContent.trim() : productLink.textContent.trim();
    return text || 'Shop nu';
  }

  function bindPillarProductClickTracking() {
    if (window.__shokzPillarProductClickBound) return;
    window.__shokzPillarProductClickBound = true;

    document.addEventListener('click', function (event) {
      var imageTarget = event.target.closest(
        '.section-pillar-product .product-card-container .swiper-slide .product-image-link .feature-row__image-wrapper'
      );
      if (imageTarget) {
        var imageSlide = imageTarget.closest('.swiper-slide');
        if (imageSlide) trackSelectItem(imageSlide, 'PRODUCT image');
        return;
      }

      var productLink = event.target.closest(
        '.section-pillar-product .product-card-container .swiper-slide .product-link'
      );
      if (productLink) {
        var productLinkSlide = productLink.closest('.swiper-slide');
        if (productLinkSlide) {
          trackSelectItem(productLinkSlide, getProductLinkButtonName(productLink));
        }
        return;
      }

      var nameLink = event.target.closest(
        '.section-pillar-product .product-card-container .swiper-slide .product-name-link'
      );
      if (!nameLink) return;

      var nameSlide = nameLink.closest('.swiper-slide');
      if (nameSlide) trackSelectItem(nameSlide, 'product title');
    });
  }

  function initPillarProductGaTracking(root) {
    initPillarProductViewTracking(root);
    bindPillarProductClickTracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPillarProductGaTracking();
    });
  } else {
    initPillarProductGaTracking();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initPillarProductViewTracking(event.target);
  });
})();
